<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Амбулаторийн бүртгэл болон үзлэгийн цаг</h3>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                    </colgroup>
                    <thead>
                        <tr>
                            <th colspan="2">Ангилал</th>
                            <th colspan="2">Амбулаторийн бүртгэл болон үзлэгийн цаг</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="2">Амбулаторийн бүртгэл</td>
                            <td rowspan="2">Ажлын өдөр</td>
                            <td>Үдээс өмнө</td>
                            <td>08:30 ~ 11:45</td>
                        </tr>
                        <tr>
                            <td>Үдээс хойш</td>
                            <td>12:30 ~ 16:45</td>
                        </tr>
                        <tr>
                            <td rowspan="2">Үзлэгийн цаг</td>
                            <td rowspan="2">Ажлын өдөр</td>
                            <td>Үдээс өмнө</td>
                            <td>09:00 ~ 12:00</td>
                        </tr>
                        <tr>
                            <td>Үдээс хойш</td>
                            <td>13:00 ~ 17:00</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="mt10 font-sub">
                ※ Бямба гарагт үзлэг эмчилгээ хийхгүй.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        mounted() {
        },
    }
</script>